import ArrayHelper from "@/common/helper/ArrayHelper";
import readXlsxFile from "read-excel-file";
import $ from "jquery";
import moment from "moment";
import TimecardService from "@/service/TimecardService";
import SweetAlertService from "@/service/SweetAlertService";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../constants/Settings";

// 文件读取器的默认ID
const fileReaderDefaultID = "fileReader";

//get Position and AttnType based on TempID from AcsCtrTerm table
const AttendanceImport = {
  async esia(value) {
    let allLines = value.split(/\r\n|\n/);
    const obj = [];
    const indexToRemove = 0;
    const numberToRemove = 4;
    allLines.splice(0, 4); //remove first 4 lines
    allLines = allLines.filter(
      x =>
        x !== "Daily Closing Detail Information(Individual)" &&
        x !==
          "Date,Weekday,Attendance Time,Attendance Reader,Punch Out Time,Punch Out reader,Work,Overtime 0,Leaving Early,Lateness,Status" &&
        x !== "Name,Employee Number,Department" &&
        x !== "Daily Closing Basic Information(Individual)" &&
        !x.includes(" / ") &&
        x
    );
    let attendanceForOneEmpRef = { EmpRef: "", TimeCard: [] };
    allLines.forEach((line, i) => {
      const indices = this.findIndices(",", line);
      const firstStrBeforeComma = line.substring(0, line.indexOf(","));
      const formatString = moment(firstStrBeforeComma, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );

      if (formatString == "Invalid date") {
        if (i !== 0) {
          obj.push(attendanceForOneEmpRef);
          attendanceForOneEmpRef = {
            EmpRef: line.substring(indices[0] + 1, indices[1]),
            TimeCard: []
          };
        }
        if (i === 0) {
          attendanceForOneEmpRef.EmpRef = line.substring(
            indices[0] + 1,
            indices[1]
          );
        }
      } else {
        const dateTimeCard = formatString;
        const clockIn = line.substring(indices[1] + 1, indices[2]);
        const clockOut = line.substring(indices[3] + 1, indices[4]);
        const InTempID = line.substring(indices[2] + 1, indices[3]);
        const OutTempID = line.substring(indices[4] + 1, indices[5]);
        const IsFromApp = false;
        const timecard = {
          UserID: "",
          DateTimeCard: dateTimeCard,
          ClockIn: clockIn,
          ClockOut: clockOut,
          IsFromApp: IsFromApp,
          InTempID: InTempID,
          OutTempID: OutTempID
        };
        if (timecard.ClockIn || timecard.ClockOut) {
          attendanceForOneEmpRef.TimeCard.push(timecard);
        }
      }

      if (i === allLines.length - 1) {
        obj.push(attendanceForOneEmpRef);
      }
    });
    const objWithTimeCard = obj.filter(x => x.TimeCard.length > 0);
    let timeCardList = [];

    objWithTimeCard.forEach(card => {
      card.TimeCard.forEach(time => {
        const cardData1 = {
          EmpRef: card.EmpRef,
          DateTimeCard: moment(time.DateTimeCard)
            .add(time.ClockIn)
            .format("YYYY-MM-DD HH:mm:ss"),
          TempID: time.InTempID
        };
        const cardData2 = {
          EmpRef: card.EmpRef,
          DateTimeCard: moment(time.DateTimeCard)
            .add(time.ClockOut)
            .format("YYYY-MM-DD HH:mm:ss"),
          TempID: time.OutTempID
        };
        timeCardList.push(cardData1);
        timeCardList.push(cardData2);
      });
    });

    const response = await TimecardService.insertOrUpdateTimecard({
      model: timeCardList
    });
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
    }
  },

  formatDate(numb) {
    const time = new Date((numb - 1) * 24 * 3600000 + 1);
    time.setYear(time.getFullYear() - 70);
    return moment(time, "YYYY-MM-DDTHH:mm:ss")
      .add(-8, "hours")
      .format("YYYY-MM-DD HH:mm:ss");
  },

  async ecinfo(fileReaderID = fileReaderDefaultID) {
    try {
      var XLSX = require("xlsx");
      const input = $(`#${fileReaderID}`);
      let reader = new FileReader();
      reader.readAsBinaryString(input[0].files[0]);
      reader.onload = async e => {
        let workbook = XLSX.read(e.target.result, { type: "binary" });
        let sheetList = workbook.SheetNames;
        let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
          defval: ""
        });
        rows = rows.map(obj => Object.values(obj));
        rows.splice(0, 5);
        let tempCardList = [];
        for (let row of rows) {
          if (row[5]) {
            tempCardList.push({
              EmpRef: row[5],
              DatetimeCard: this.formatDate(row[1]),
              TempID: row[9]
            });
          }
        }

        const response = await TimecardService.insertOrUpdateTimecard({
          model: tempCardList
        });
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      };
    } catch (e) {
      // console.log("🚀 ~ file: AttendanceImport.js ~ line 132 ~ ecinfo ~ e", e)
    }
  },

  // Old Code
  // async ecinfo() {
  //   const input = $("#fileReader");
  //   try {
  //     readXlsxFile(input[0].files[0], { sheet: "Sheet1" }).then(async (rows) => {
  //       rows.splice(0, 9);
  //       let tempCardList = [];
  //       for (let row of rows) {
  //         if (row[5]) {
  //           tempCardList.push({
  //             DatetimeCard: this.formatDate(row[1]),
  //             Local: row[3],
  //             CardID: row[5],
  //             Dept: row[9],
  //             userEngName: row[11],
  //             userChiName: row[13],
  //             Group: row[15],
  //             Remark: row[19]
  //           })
  //         }
  //       }
  //       const userSet = new Set(tempCardList.map(x => x.CardID));
  //       const userarray = Array.from(userSet);
  //       let obj = [];
  //       for (let CardID of userarray) {
  //         let attendanceForOneEmpRef = { EmpRef: CardID, TimeCard: [] };
  //         var SortByUser = tempCardList.filter(x => x.CardID == CardID);
  //         const DateTimeCardSet = new Set(SortByUser.map(x => moment(x.DatetimeCard).format("YYYY-MM-DD")));
  //         const DateTimeCardArray = Array.from(DateTimeCardSet);
  //         for (let DateTimeCard of DateTimeCardArray) {
  //           let SortByDateTimeCard = SortByUser.filter(x => moment(x.DatetimeCard).format("YYYY-MM-DD") == DateTimeCard);
  //           SortByDateTimeCard = ArrayHelper.sortByKey(SortByDateTimeCard, "DatetimeCard", true);
  //           const timecard = {
  //             UserID: "",
  //             DateTimeCard: DateTimeCard,
  //             ClockIn: moment(SortByDateTimeCard[0].DatetimeCard).format("HH:mm:ss"),
  //             ClockOut: moment(SortByDateTimeCard[SortByDateTimeCard.length - 1].DatetimeCard).format("HH:mm:ss"),
  //             IsFromApp: false,
  //           };
  //           attendanceForOneEmpRef.TimeCard.push(timecard)
  //         }
  //         obj.push(attendanceForOneEmpRef);
  //       }
  //       const objWithTimeCard = obj.filter((x) => x.TimeCard.length > 0);

  //       const response = await TimecardService.insertOrUpdateTimecard({
  //         model: objWithTimeCard,
  //       });
  //       if (response.data.IsSuccess) {
  //         SweetAlertService.success("Success", response.data.Message);
  //       } else {
  //         SweetAlertService.warning("Warn", response.data.Message);
  //       }
  //     })
  //   } catch (e) {
  // //     console.log("🚀 ~ file: AttendanceImport.js ~ line 132 ~ ecinfo ~ e", e)

  //   }
  // },
  async test(value, fileReaderID = fileReaderDefaultID) {
    this.sailingBoat(value, fileReaderID);
  },
  async essilor(fileReaderID = fileReaderDefaultID) {
    const input = $(`#${fileReaderID}`);
    readXlsxFile(input[0].files[0], { sheet: "Sheet1" }).then(async rows => {
      let objWithTimeCard = [];
      rows.splice(0, 1);
      for (let row of rows) {
        if (
          moment(row[6], "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss") !=
          "Invalid date"
        ) {
          const dateTime = moment(row[3], "YYYY-MM-DD HH:mm:ss")
            .format("YYYY-MM-DD")
            .add(moment(row[6], "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"));
          objWithTimeCard.push({
            EmpRef: row[0].replace("'", ""),
            DateTimeCard: dateTime,
            TempID: row[1]
          });
        }
      }

      const response = await TimecardService.insertOrUpdateTimecard({
        model: objWithTimeCard
      });
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    });
  },

  // Old Code
  // async essilor() {
  //   const input = $("#fileReader");
  //   readXlsxFile(input[0].files[0], { sheet: "Sheet1" }).then(async (rows) => {
  //     let objWithTimeCard = [];
  //     rows.splice(0, 1);
  //     console.log("rows", rows);
  //     for (let row of rows) {
  //       if (moment(row[6], "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss") != 'Invalid date') {
  //         objWithTimeCard.push({
  //           EmpRef: row[0].replace("'", ''),
  //           TimeCard: [{
  //             UserID: "",
  //             DateTimeCard: moment(row[3], "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
  //             ClockIn: moment(row[6], "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"),
  //             ClockOut: moment(row[7], "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"),
  //             IsFromApp: false
  //           }]
  //         })
  //       }
  //     }
  //     console.log("objWithTimeCard", objWithTimeCard);

  //     const response = await TimecardService.insertOrUpdateTimecard({
  //       model: objWithTimeCard,
  //     });
  //     if (response.data.IsSuccess) {
  //       SweetAlertService.success("Success", response.data.Message);
  //     } else {
  //       SweetAlertService.warning("Warn", response.data.Message);
  //     }
  //   })
  // },

  async BEX(fileReaderID = fileReaderDefaultID) {
    var XLSX = require("xlsx");
    const input = $(`#${fileReaderID}`);
    let reader = new FileReader();
    reader.readAsBinaryString(input[0].files[0]);
    reader.onload = async e => {
      let workbook = XLSX.read(e.target.result, { type: "binary" });
      let sheetList = workbook.SheetNames;
      let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
        defval: ""
      });
      rows = rows.map(obj => Object.values(obj));
      let TimeCardObj = [];
      for (let row of rows) {
        let temp;
        temp = {
          EmpRef: row[0].replace("'", ""),
          DateTimeCard: this.formatDate(row[3]),
          TempID: row[5]
        };
        TimeCardObj.push(temp);
      }

      const response = await TimecardService.insertOrUpdateTimecard({
        model: TimeCardObj
      });
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    };
  },
  // Old Code
  // async BEX() {
  // const value - {asdra:lakwdj}.lakwdj
  //   const input = $("#fileReader");
  //   const sysParams = store.getters[StoreGetter.sysParams];
  //   const clockInString = sysParams.find((x) => x.ParamCode == 'CLOCKIN').ParamVal;
  //   const clockOutString = sysParams.find((x) => x.ParamCode == 'CLOCKOUT').ParamVal;
  //   readXlsxFile(input[0].files[0], { sheet: "Original Records Report" }).then(async (rows) => {
  //     rows.splice(0, 1);
  //     let inList = [];
  //     let outList = [];
  //     for (let row of rows) {
  //       let temp = {
  //         EmpRef: row[0].replace("'", ''),
  //         UserName: row[1],
  //         TimeCard: moment(row[3], "YYYY-MM-DDTHH:mm:ss").add(-8, 'hours').format("YYYY-MM-DD HH:mm:ss"),
  //         CheckPoint: row[5],
  //       }
  //       if (temp.CheckPoint == clockInString) {
  //         inList.push(temp);
  //       } else if (temp.CheckPoint == clockOutString) {
  //         outList.push(temp);
  //       }
  //     }

  //     const userSet = new Set(inList.map(x => x.EmpRef));
  //     const TimeCardObj = Array.from(userSet).map(x => {
  //       return {
  //         EmpRef: x, TimeCard: []
  //       }
  //     });
  //     while (inList.length > 0) {
  //       const EmpRef = inList[0].EmpRef;
  //       const maxRange = moment(inList[0].TimeCard, "YYYY-MM-DD HH:mm:ss").add(1, 'Days').format("YYYY-MM-DD") + " 06:00:00";
  //       const minRange = inList[0].TimeCard;
  //       let OutTimeList = outList.filter(x => x.EmpRef == EmpRef && x.TimeCard > minRange && x.TimeCard < maxRange);
  //       OutTimeList = ArrayHelper.sortByKey(OutTimeList, "TimeCard");
  //       const OutTime = OutTimeList[OutTimeList.length - 1];
  //       const timecard = {
  //         UserID: "",
  //         DateTimeCard: moment(inList[0].TimeCard, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
  //         ClockIn: moment(inList[0].TimeCard, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"),
  //         ClockOut: OutTime ? moment(OutTime.TimeCard, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss") : "",
  //         IsFromApp: false,
  //       };
  //       const index = TimeCardObj.findIndex(x => x.EmpRef == EmpRef);
  //       TimeCardObj[index].TimeCard.push(timecard);
  //       inList = inList.filter(x => !(x.EmpRef == EmpRef && x.TimeCard < maxRange));
  //     }
  //     const response = await TimecardService.insertOrUpdateTimecard({
  //       model: TimeCardObj,
  //     });
  //     if (response.data.IsSuccess) {
  //       SweetAlertService.success("Success", response.data.Message);
  //     } else {
  //       SweetAlertService.warning("Warn", response.data.Message);
  //     }
  //   }).2

  // },

  async DMC(fileReaderID = fileReaderDefaultID) {
    var XLSX = require("xlsx");
    const input = $(`#${fileReaderID}`);
    let reader = new FileReader();
    reader.readAsBinaryString(input[0].files[0]);
    reader.onload = async e => {
      let workbook = XLSX.read(e.target.result, { type: "binary" });
      let sheetList = workbook.SheetNames;
      let json = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
        defval: ""
      });
      json = json.map(obj => Object.values(obj));
      let timeCardList = [];
      json.forEach(data => {
        if (data[6]) {
          let timeData = {
            EmpRef: data[1].replace("'", "").replace(/(^[\s]*)|([\s]*$)/g, ""),
            DateTimeCard: moment(data[3], "YYYY-MM-DD")
              .add(data[6])
              .format("YYYY-MM-DD HH:mm:ss"),
            TempID: ""
          };
          timeCardList.push(timeData);
        }
        if (data[8]) {
          let timeData = {
            EmpRef: data[1].replace("'", "").replace(/(^[\s]*)|([\s]*$)/g, ""),
            DateTimeCard: moment(data[3], "YYYY-MM-DD")
              .add(data[8])
              .format("YYYY-MM-DD HH:mm:ss"),
            TempID: ""
          };
          timeCardList.push(timeData);
        }
      });
      const response = await TimecardService.insertOrUpdateTimecard({
        model: timeCardList
      });
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    };
  },

  // Old Code
  // async DMC() {
  //   const input = $("#fileReader");
  //   readXlsxFile(input[0].files[0], { sheet: "ExcelData" }).then(async (rows) => {
  //     let modelList = [];
  //     rows.splice(0, 1);
  //     for (let row of rows) {
  //       const dateON = row[6] ? row[6] : '';
  //       const dateIN = row[8] ? row[8] : '';
  //       modelList.push({
  //         EmpRef: row[1].replace("'", ''),
  //         TimeCard: [{
  //           UserID: "",
  //           DateTimeCard: moment(row[3], "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
  //           ClockIn: dateON,
  //           ClockOut: dateIN,
  //           IsFromApp: false
  //         }]
  //       })
  //     }
  //     let TimeCardObj = [];
  //     for (let i in modelList) {
  //       const index = TimeCardObj.findIndex((x) => { return x.EmpRef == modelList[i].EmpRef })
  //       if (index != -1) {
  //         TimeCardObj[index].TimeCard.push(modelList[i].TimeCard[0])
  //       } else {
  //         TimeCardObj.push({
  //           EmpRef: modelList[i].EmpRef,
  //           TimeCard: modelList[i].TimeCard
  //         })
  //       }
  //     }

  //     const response = await TimecardService.insertOrUpdateTimecard({
  //       model: TimeCardObj,
  //     });
  //     if (response.data.IsSuccess) {
  //       SweetAlertService.success("Success", response.data.Message);
  //     } else {
  //       SweetAlertService.warning("Warn", response.data.Message);
  //     }
  //   })
  // },

  formatDateTime(date, time) {
    const datetimeString = `20${date.slice(0, 2)}-${date.slice(
      2,
      4
    )}-${date.slice(4)}T${time.slice(0, 2)}:${time.slice(2, 4)}:00.000`;
    const datetime = new Date(datetimeString);
    console.log("formatDateTime", date, time, datetimeString, datetime);

    const formattedDatetime = moment(datetime).format(
      Settings.DateTime.yyyymmddhhmmss
    );

    return formattedDatetime;
  },
  convertExcelDate(excelDate) {
    // Excel 序列号从 1900-01-01 开始，但 JavaScript Date 从 1970-01-01 开始
    // 1900-01-01 对应的 JavaScript 时间戳为 -2209161600000 毫秒
    const date = new Date((excelDate - (excelDate >= 60 ? 2 : 1)+2) * 24 * 60 * 60 * 1000 - 2209161600000);
    
    // 格式化日期为 YYYY-MM-DD HH:MM:SS 格式
    return date.toISOString().slice(0, 19).replace('T', ' ');
  },
  sailingBoat(value, fileReaderID = fileReaderDefaultID) {
    console.log("value----sailingboat", value);
    try {
      var XLSX = require("xlsx");
      const input = $(`#${fileReaderID}`);
      console.log(input, "------input");
      let reader = new FileReader();
      const file = input[0].files[0];
      const ext = file.name.split(".").pop();
      reader.readAsBinaryString(file);
      reader.onload = async e => {
        let tempCardList = [];
        let workbook = XLSX.read(e.target.result, { type: "binary" });
        let sheetList = workbook.SheetNames;
        let rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
          defval: ""
        });
        if (ext.toLowerCase() === "xlsx" || ext.toLowerCase() === "xls") {
          console.log(rows, "-------rows");
          var msInDay = 24 * 60 * 60 * 1000; // 一年的毫秒数
          let CompCode=store.getters[StoreGetter.user].CompCode;
          rows.forEach(row => {
            if (CompCode == "DMC") {
              // 去除键名中的空格
              const cleanedRow = Object.keys(row).reduce(
                (acc, key) => {
                  acc[key.replace(/\s+/g, "")] = row[key];
                  return acc;
                },
                {}
              );
              //提取卡号部分
              row.CardID = cleanedRow["UserID"].replace(/\s+/g, "");
              // 提取日期部分
              const datePart = cleanedRow["Date"].split(" ")[0];
              // 组合签入的日期和时间
              row.ActIn = `${datePart} ${cleanedRow["AMOnDuty"]}`;
              // 组合签出的日期和时间
              row.ActOut = `${datePart} ${cleanedRow["PMOffDuty"]}`;
            }
            tempCardList.push({
              EmpRef: row.CardID,
              DatetimeCard:CompCode == "DMC"? row.ActIn:this.convertExcelDate(row.ActIn),
              TermID: ""
            });
            tempCardList.push({
              EmpRef: row.CardID,
              DatetimeCard:CompCode == "DMC"? row.ActOut:this.convertExcelDate(row.ActOut),
              TermID: ""
            });
          });
        } else {
          let A1Row = workbook.Sheets[sheetList[0]]["A1"];
          if (A1Row) {
            rows.unshift({
              [A1Row.v]: A1Row.v
            });
          }
          rows = rows.map(obj => Object.values(obj)[0]);
          // rows.splice(0, 5);
          console.log(rows, "------rows");
          // for (let row of rows) {
          //   const date = this.formatDate(row[7]);
          //   if (row[13] && row[0]) {
          //     const time = moment(row[13], Settings.DateTime.hhmm).format(
          //       Settings.DateTime.hhmmss
          //     );
          //     if (time != "Invalid date") {
          //       const dateTime =
          //         moment(date).format(Settings.DateTime.yyyymmdd) + ` ${time}`;
          //       tempCardList.push({
          //         EmpRef: row[0],
          //         DatetimeCard: dateTime,
          //         TempID: row[4]
          //       });
          //     }
          //   }
          //   if (row[19] && row[0]) {
          //     const time = moment(row[19], Settings.DateTime.hhmm).format(
          //       Settings.DateTime.hhmmss
          //     );
          //     if (time != "Invalid date") {
          //       const dateTime =
          //         moment(date).format(Settings.DateTime.yyyymmdd) + ` ${time}`;
          //       tempCardList.push({
          //         EmpRef: row[0],
          //         DatetimeCard: dateTime,
          //         TempID: row[4]
          //       });
          //     }
          //   }
          // }
          for (let row of rows) {
            const parts = row.split(/[\s:]+/);
            // const date = this.formatDate("20" + parts[0]);
            const time = moment(parts[1], Settings.DateTime.hhmm).format(
              Settings.DateTime.hhmmss
            );
            if (time != "Invalid date") {
              console.log(parts[0], parts[1], "----parts[0], parts[1]");
              const dateTime = this.formatDateTime(parts[0], parts[1]);
              tempCardList.push({
                EmpRef: parts[3],
                DatetimeCard: dateTime,
                TempID: parts[2]
              });
            }
          }
        }

        console.log("===tempCardList===", tempCardList);
        const response = await TimecardService.insertOrUpdateTimecard({
          model: tempCardList
        });
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      };
    } catch (e) {
      // console.log("🚀 ~ file: AttendanceImport.js ~ line 132 ~ ecinfo ~ e", e)
    }
  },

  sailingBoatExcel(fileReaderID = fileReaderDefaultID) {
    console.log("sailingBoatExcel==================");
    var XLSX = require("xlsx");
    const input = $(`#${fileReaderID}`);
    let reader = new FileReader();
    const file = input[0].files[0];
    const ext = file.name.split(".").pop();
    reader.readAsBinaryString(input[0].files[0]);
    reader.onload = async e => {
      let timeCardList = [];
      let workbook = XLSX.read(e.target.result, {
        type: "binary"
      });
      let sheetList = workbook.SheetNames;
      let json = XLSX.utils.sheet_to_json(workbook.Sheets[sheetList[0]], {
        defval: ""
      });
      if (ext.toLowerCase() === "xlsx" || ext.toLowerCase() === "xls") {
        let CompCode=store.getters[StoreGetter.user].CompCode;
        json.forEach(row => {
          if (CompCode == "DMC") {
            // 去除键名中的空格
            const cleanedRow = Object.keys(row).reduce(
              (acc, key) => {
                acc[key.replace(/\s+/g, "")] = row[key];
                return acc;
              },
              {}
            );
            //提取卡号部分
            row.CardID = cleanedRow["UserID"].replace(/\s+/g, "");
            // 提取日期部分
            const datePart = cleanedRow["Date"].split(" ")[0];
            // 组合签入的日期和时间
            row.ActIn = `${datePart} ${cleanedRow["AMOnDuty"]}`;
            // 组合签出的日期和时间
            row.ActOut = `${datePart} ${cleanedRow["PMOffDuty"]}`;
          }
          timeCardList.push({
            EmpRef: row.CardID,
            DatetimeCard:CompCode == "DMC"? row.ActIn:this.convertExcelDate(row.ActIn),
            TermID: ""
          });
          timeCardList.push({
            EmpRef: row.CardID,
            DatetimeCard:CompCode == "DMC"? row.ActOut:this.convertExcelDate(row.ActOut),
            TermID: ""
          });
        });
      } else {
        json = json.map(obj => Object.values(obj));
        json.forEach(data => {
          if (data[6]) {
            let timeData = {
              EmpRef: data[1]
                .replace("'", "")
                .replace(/(^[\s]*)|([\s]*$)/g, ""),
              DateTimeCard: moment(data[3], "YYYY-MM-DD")
                .add(data[6])
                .format("YYYY-MM-DD HH:mm:ss"),
              TempID: ""
            };
            timeCardList.push(timeData);
          }
          if (data[8]) {
            let timeData = {
              EmpRef: data[1]
                .replace("'", "")
                .replace(/(^[\s]*)|([\s]*$)/g, ""),
              DateTimeCard: moment(data[3], "YYYY-MM-DD")
                .add(data[8])
                .format("YYYY-MM-DD HH:mm:ss"),
              TempID: ""
            };
            timeCardList.push(timeData);
          }
        });
      }
      const response = await TimecardService.insertOrUpdateTimecard({
        model: timeCardList
      });
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    };
  },
  findIndices(substring, string) {
    var a = [],
      i = -1;
    while ((i = string.indexOf(substring, i + 1)) >= 0) a.push(i);
    return a;
  }
};

export default AttendanceImport;



// WEBPACK FOOTER //
// ./src/service/AttendanceImport.js